import './styles.scss';
import './js/menu.js';
import "./js/videos.js";
import "./js/slider.js";

window.$ = window.jQuery = require("jquery");

/*
function _calculateCaptionWidth() {

    const imageWrapperItems = document.querySelectorAll(".image-wrapper");

    if(imageWrapperItems){
        imageWrapperItems.forEach((imageWrapperItem) => {
            let imageItem = imageWrapperItem.firstElementChild;
            if(imageItem){
                let imageItemWidth = imageItem.clientWidth;
                let captionItem = imageItem.nextElementSibling;
                if(captionItem){
                    captionItem.style.width = imageItemWidth + 'px';
                }
            }
        });
    }
}

window.addEventListener('resize', _calculateCaptionWidth, false);
document.addEventListener('DOMContentLoaded', _calculateCaptionWidth, false);
window.addEventListener('load', _calculateCaptionWidth);

Promise.all(Array.from(document.images).map(img => {
    if (img.complete)
        return Promise.resolve(img.naturalHeight !== 0);
    return new Promise(resolve => {
        img.addEventListener('load', () => resolve(true));
        img.addEventListener('error', () => resolve(false));
    });
})).then(results => {
    if (results.every(res => res)) {
        console.log('all images loaded successfully');
        _calculateCaptionWidth();
    } else {
        console.log('some images failed to load, all finished loading');
        _calculateCaptionWidth();
    }
});
*/